import React from 'react';
import { plusDefault } from '../../data/products';
import './index.less';

interface ISmallSubscribeBannerProps {
	title?: string;
	subtitle?: string;
	buttonUrl?: string;
	buttonLabel?: string;
}

export class SmallSubscribeBanner extends React.Component<ISmallSubscribeBannerProps> {
	render() {
		const title = this.props.title || 'Watch the Bible Come Alive with Faithlife TV Plus';
		const buttonUrl = this.props.buttonUrl || plusDefault.url;
		const buttonLabel = this.props.buttonLabel || 'Start your free trial';

		return (
			<div className="small-subscribe-banner">
				<div className="header">
					<div className="wrapper">
						<h1>{title}</h1>
						<a href={buttonUrl}>
							<button>{buttonLabel}</button>
						</a>
					</div>
				</div>
			</div>
		);
	}
}
